<template>
  <div class="markPage">
    <Header theme="white"></Header>

    <div class="bannerWrap">
      <div class="mainTit">
        <span class="active">证书列表</span>
      </div>
      <!-- <div class="sunTit">
        / Application market
      </div> -->
    </div>
    <div class="content">
      <div class="container">
        <div class="leftMenu">
          <div class="menuItem" :class="{ 'menuItemActive': active === idx}" v-for="(item, idx) in tabsList" :key="idx"
            @click="handleClick(item, idx)">
            {{item.name}}
            <span class="arrow" v-if="id === item.id">➞</span>
          </div>
        </div>
        <div class="rightContent">
          <template v-if="tabsData.length">
            <div class="cItem" v-for="(item, idx) in tabsData" :key="idx" @click="goDetail(item)" >
              <div class="cItemTit">
                <span class="label">证书编号：</span><span class="value">{{item.asyncDetail.code}}</span>
              </div>
<!--              <div class="myBtn" @click="goYYDetail(item.id)">查看应用详情 ➞</div>-->
            </div>
          </template>
          <template v-else>
            <div class="noData">
              <img src="../../assets/images/zwsj@2x.png" />
              <div>暂无数据</div>
            </div>
          </template>


        </div>
      </div>
    </div>
    <el-dialog
      :title="title"
      :visible.sync="open"
      width="800px"
      class="dialogLand"
      append-to-body
    >
      <div class="cItemTit cItemTit1">
        <div>
          <span class="label">证书编号：</span><span class="value">{{detail.asyncDetail.code}}</span>
        </div>
        <div>
          <span class="label">产品名称：</span><span class="value">{{detail.asyncDetail.name }}</span>
        </div>
      </div>
      <div class="cItemTit cItemTit1">
        <div>
          <span class="label">产品型号：</span><span class="value">{{detail.asyncDetail.model }}</span>
        </div>
        <div>
          <span class="label">认证委托人：</span><span class="value">{{detail.asyncDetail.client }}</span>
        </div>
      </div>
      <div class="cItemTit cItemTit1">
        <div>
          <span class="label">生产企业：</span><span class="value">{{detail.asyncDetail.entName }}</span>
        </div>
        <div>
          <span class="label">制造商：</span><span class="value">{{detail.asyncDetail.maker }}</span>
        </div>
      </div>
      <div class="cItemTit cItemTit1">
        <div>
          <span class="label">认证标准：</span><span class="value">{{detail.asyncDetail.standard }}</span>
        </div>
        <div>
          <span class="label">证书状态变化时间：</span><span class="value">{{detail.asyncDetail.changeDate }}</span>
        </div>
      </div>
      <div class="cItemTit cItemTit1">
        <div>
          <span class="label">原因：</span><span class="value">{{detail.asyncDetail.reason}}</span>
        </div>
        <div>
          <span class="label">证书附件：</span><span class="value">{{detail.asyncDetail.annex}}</span>
        </div>
      </div>
      <div class="cItemTit cItemTit1">
        <div>
          <span class="label">证书状态：</span><span class="value">{{detail.asyncDetail.status }}</span>
        </div>
        <div>
          <span class="label">发证日期：</span><span class="value">{{detail.asyncDetail.issueDate }}</span>
        </div>
      </div>
      <div class="cItemTit cItemTit1">
        <div>
          <span class="label">首次发证日期：</span><span class="value">{{detail.asyncDetail.frstDate }}</span>
        </div>
        <div>
          <span class="label">有效期至：</span><span class="value">{{detail.asyncDetail.expiryDate }}</span>
        </div>
      </div>
      <div v-if="detail.asyncUrl" class="cItemTit" style="position: absolute;right: 54px;top: 54px;">
        <img class="codeImage" :src="detail.asyncUrl" alt="" srcset="" />
        <div class="codeText">方圆CQM码</div>
      </div>
      <div class="image-gallery">
        <div class="image-container" v-for="(item, idx) in detail.asyncDetail.paths" :key="idx">
          <img class="image" :src="item" alt="" srcset="" />
        </div>
      </div>
    </el-dialog>
    <!--页脚-->
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import {
  serverUrl
} from '@/utils/server.js'
import {
  fethCertificateList
} from '@/api/api'
import axios from 'axios'
import {get} from '../../utils/request'
import {userInfo} from '../../api/api'
const QR = require('@/utils/weapp-qrcode.js')
export default {
  data() {
    return {
      baseUrl: serverUrl.baseURL,
      tabsList: [
        {
          name: '自愿性产品认证证书',
          id: '2'
        }
      ],
      tabsData: [],
      id: '',
      pageNum: 1,
      pageSize: 10,
      total: 0,
      name: '',
      active: 0,
      // 弹出层标题
      title: '证书详情',
      // 是否显示弹出层
      open: false,
      detail: {
        asyncDetail: {
          code: '',
          name: '',
        },
        asyncUrl: ''
      },
      companyName: null
    }
  },
  components: {
    Header,
    Footer
  },
  mounted() {

    this.name = localStorage.getItem('name')
    // this.handleClick()
    // this.getTabsData()
  },
  created () {
    this.getUserInfo()

  },
  methods: {
    /* handleClick(item, index) {
      this.id = item.id
      this.active = index
      this.getTabsData()
    }, */
    getUserInfo() {
      userInfo().then(res => {
        this.companyName = res.data.companyName
        this.getTabsData()
      })
    },
    goDetail(item) {
      this.open = true
      //根据id调用后端给的接口
      this.detail = item
    },
    getTabsData() {
      // console.log('================', this.companyName)
      let params = {
        pageNum: this.pageNum - 1,
        size: 999,
        name: this.companyName,


      }
      fethCertificateList(params).then(res => {
        res.data.list.map(item => {
          const data = {
            asyncUrl: QR.drawImg(item.asyncUrl, {
              typeNumber: 4,
              errorCorrectLevel: 'M',
              size: 196 // 创建尺寸，用于下载
            }),
            asyncDetail: JSON.parse(item.asyncDetail)
          }
          this.tabsData.push(data)
        })
        console.log('****************************************', this.tabsData)
        this.total = parseInt(res.data.total)
      })

      // axios.get('https://fyyun.cqm.cn/api/api/external/customPage/entCertificate?name=555556&pageNum=1').then(res => {
      //   console.log('****************************************', res)
      //   this.tabsData = res.data.list
      //   this.total = parseInt(res.data.total)
      // })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getTabsData()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.getTabsData()
    },
  }
}
</script>

<style scoped>
  .markPage {
    background: rgba(249, 249, 249, 1);
  }

  .container {
    width: 1300px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    margin-top: 77px;
    margin-bottom: 45px;
  }

  .leftMenu {
    width: 270px;
    min-height: 1000px;
    background: #FFFFFF;
    margin-right: 20px;
    box-sizing: border-box;
  }

  .menuItem {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #121E30;
    width: 100%;
    height: 60px;
    line-height: 60px;
    text-align: center;
    cursor: pointer;
    position: relative;
  }

  .menuItemActive {
    background: linear-gradient(90deg, #0F5EFF, rgba(20, 137, 246, 0.6));
    color: #fff;
  }

  .rightContent {
    background: #fff;
    flex: 1;
    padding: 20px;
    min-height: 1000px;
    box-sizing: border-box;
  }

  .cItem {
    border-bottom: 1px dashed rgba(218, 223, 231, 1);
    padding: 20px 0;
    position: relative;
  }

  .cItemTit1 {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .label {
    min-width: 80px;
    display: inline-block;
  }

  .cItemTit1 > div {
    width: 40%;
  }

  .cItemTit {
    margin-bottom: 24px;
  }

  .cItemTit .icon {
    width: 30px;
    height: 30px;
    vertical-align: middle;
  }
  .codeImage {
    width: 139px;
    height: 139px;
  }
  .codeText {
    font-family: Source Han Sans CN;
    font-weight: bold;
    font-size: 20px;
    color: #002172;
    line-height: 26px;
    text-align: center;
  }
  .yyimg {
    width: 200px;
    height: 250px;
  }
  .cItemTit .tit {
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #121E30;
    padding: 0 12px;
    vertical-align: middle;
  }

  .cItemTit .num {
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #0F5EFF;
    background: #EDF2FF;
    border-radius: 4px;
    padding: 6px 10px;
    vertical-align: middle;
  }

  .cItemText {
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #516381;
    line-height: 24px;
    width: 80%;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    word-break: break-all;
  }

  .noData {
    width: 100%;
    height: 1000px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .noData img {
    width: 211px;
    height: 180px;
    margin-bottom: 20px;
  }

  .noData {
    font-size: 16px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #A8ADB9;
  }
  .image-gallery {
    display: flex;
    flex-wrap: wrap;
  }

  .image-container {
    margin-right: 20px; /* 设置图片之间的间隔 */
    margin-bottom: 20px; /* 设置图片之间的间隔 */
  }

  .image {
    width: auto; /* 或者设置固定宽度 */
    height: 259px; /* 保持图片的宽高比 */
  }
  /*.cItemTit{
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #121E30;
  padding-bottom: 20px;
}
.cLeft{
  width: 80%;
}
.cItemText{
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #516381;
  line-height: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  word-break: break-all;
}
.pageBox{
  padding: 20px 0;
  display: flex;
  justify-content: flex-end;
}*/
  .myBtn {
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #0F5EFF;
    padding: 7px 15px;
    border: 2px solid #0F5EFF;
    border-radius: 25px;
    display: inline-block;
    margin-right: 20px;
    cursor: pointer;
    position: absolute;
    right: 0;
    top: 40px;
  }

  .bannerWrap {
    width: 100%;
    height: 480px;
    background: url('../../assets/images/yysc_BJ@2x.png') top center no-repeat;
    background-size: 100% 100%;
    padding: 265px 0 0 60px;
    box-sizing: border-box;
  }

  .mainTit {
    font-size: 48px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #346392;
    margin-bottom: 44px;
    cursor: pointer;
  }

  .mainTit span.active {
    color: #fff;
  }

  .sunTit {
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #FFFFFF;
  }

  .arrow {
    position: absolute;
    right: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/views/market/CertificatePage.vue